<template>
    <div class="modal h-100" tabindex="-1" role="dialog">
       <div class="modal-dialog" role="document">
           <div class="modal-content">
               <div class="modal-header p-2" style="height: 64px;display: flex;align-items: center;">
                   <h5 class="modal-title ml-2">{{$t('My Preferences')}}</h5>
                   <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close()">
                       <span aria-hidden="true"><cancel-icon class="close-icon" style="height: 35px !important;
    width: 35px !important;
    color: #fff;"></cancel-icon></span>
                   </button>
               </div>
               <div class="modal-body p-0 d-inline-flex row m-0" style="display: flex !important;
               width: 100%;flex-direction:row;cursor:pointer">
                      <div class="sidenavbar p-0" style="width:20%">
                        <ul class="sidebar-menu m-0" style="list-style-type:none;padding:4px">
                           <!-- <li v-if="isComponentEnabled('settings-user')" class="sidebar text-left p-2 mt-2" >
                             <h6 class="m-0 activeclass">Personal info</h6>
                            </li> -->
                            <li class="sidebar" v-for="panel in getRegisteredPreferencesSidemenu()" :class="{activeclass: activeIndex === panel.label}"  v-on:click="getEventHandler(panel,'onClick',panel.onEvents)" :key="panel.label">
                              <h6 class="m-0">{{$t(panel.label)}}</h6>
                            </li>
                        </ul>
                      </div>
                      <div class="p-0" style="overflow: auto;height: calc(100% - 20px);margin-bottom: 20px;width:80%">
                          <router-view
                            :name="selectedComponent">
                          </router-view>
                </div>
               </div>
           </div>
       </div>
   </div>
</template>


<script>
import Utils from "../../components.utils.js";
import {mapMutations,mapGetters,mapActions} from "vuex"
import {UserPreferencesSidemenu} from "../../registry/plugins.js"
// import ExternalPlugin from "../core/ExternalPlugin.vue"
import cancelIcon from "../core/InlineCancelField.vue"


export default {
  name: "UserPreferences",
    data() {
    return {
      showUserPref:true,
      selectedComponent:"user-info",
      preferenceSidemenulist:["userinfo","favorites","Advanced","MyApps"],
      activeIndex:"Personal Info",
      selectedExternalPluginInfo:{},
      parentRouteInfo:{}
      };
    },
    components:{
      // "external-plugin":ExternalPlugin,
        'cancel-icon':cancelIcon
    },
    computed:{
      currentProperties() {                                        //Dynamically send props
      if(this.selectedComponent === "external-plugin"){
        return {selectedPlugin : this.selectedExternalPluginInfo}
      }else{
          return {}
      }
    },
    },
    watch:{
      "$route.fullPath":function(newVal,oldVal){
        if (newVal!=oldVal){
          if (this.$route.matched[this.$route.matched.length-1].parent.name == "userPref" && this.selectedComponent != this.$route.name){
            this.changeToSelectedComponent(this.$route.name, this.$route.params.pluginId?this.$route.params.pluginId:this.$route.meta.title, false)
          }
        }
      }
    },
    methods:{
      isComponentEnabled(compName){
        return Utils.isComponentEnabled(compName)
      },
      changeToSelectedComponent(compName,label){
            this.selectedComponent = compName;
            if(label != undefined)this.activeIndex = label;
        },
        changeComponentToUserInfo(){
          this.selectedComponent = "user-info"
          this.activeIndex = "Personal Info"
          this.$router.push({
            name: "user-info",
            params: {pluginId:"Personal Info"},
            query:{}
          })
        },
        changeComponentToFavorites(){
          this.selectedComponent = "favorites-info"
          this.activeIndex = "Favorites"
          this.$router.push({
            name: "favorites-info",
            params: {pluginId:"Favorites"},
            query:{}
          })
        },
        changeComponentToAdvanced(){
          this.selectedComponent = "advanced"
          this.activeIndex = "advanced"
          this.$router.push({
            name: "advanced",
            params: {pluginId:"advanced"},
            query:{}
          })
        },
        changeComponentToMyApps(){
          this.selectedComponent = "my-apps"
          this.activeIndex = "My Apps"
          this.$router.push({
            name: "my-apps",
            params: {pluginId:"My Apps"},
            query:{}
          })
        },
        changeComponentToExternalPluginDisplay(){
          this.changeToSelectedComponent("external-plugin")
          this.activeIndex = "external-plugin"
        },
        getEventHandler(info,eventname,supportedEvents){
        if (info.externalPlugin != undefined && info.externalPlugin){
          this.selectedExternalPluginInfo = info.pluginInfo
          return this.changeComponentToExternalPluginDisplay()
        }else{
          let event = supportedEvents.filter((eventInfo) => eventInfo.event_name == eventname);
          if(event.length != 0){
            return event[0]["event_handler"]();
          }
        }
      },
      close() {
          // this.$emit('close');
        if (Object.keys(this.parentRouteInfo)!=0 && Object.keys(this.parentRouteInfo).includes("name") ){
          this.$router.push({
            name: this.parentRouteInfo.name,
            params:this.parentRouteInfo.params,
            query:Object.assign({}, this.parentRouteInfo.query?this.parentRouteInfo.query:{}),
          })
        }else{
          this.$router.push({
            name: "explorer",
          })
        }
      },
      setUpPreferencesSidemenu(sideMenuList){
          for (let sideMenu of sideMenuList) {
            if (sideMenu == "userinfo" && this.isComponentEnabled('settings-user')){
              let userEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToUserInfo,
                "handler_args":[]
              }]
              let userinfo = new UserPreferencesSidemenu("userinfo","userinfo", "Personal Info",userEvents)
              userinfo.register()
            }else if (sideMenu == "favorites"){
              let favEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToFavorites,
                "handler_args":[]
              }]
              let favInfo = new UserPreferencesSidemenu("favorites","favorites", "Favorites",favEvents)
              favInfo.register()
            }else if (sideMenu == "Advanced"){
              let advancedEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToAdvanced,
                "handler_args":[]
              }]
              let advancedInfo = new UserPreferencesSidemenu("advanced","advanced", "Advanced",advancedEvents)
              advancedInfo.register()
            }
            else if (sideMenu == "MyApps"){
              let myAppsEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToMyApps,
                "handler_args":[]
              }]
              let myAppInfo = new UserPreferencesSidemenu("myApps","myApps", "My Apps",myAppsEvents)
              myAppInfo.register()
            }
          }
      },
      registerUserPreferenceSidemenu(menu){
            this.registerPreferenceSidemenu(menu)
        },
        registorInstalledPlugins(){
        this.getInstalledPluginsFromServer().then((data) => {
          let externalPlugins = []
          if (data.statusCode == 200){
            externalPlugins = data.plugins
          }
          for (let plugin of externalPlugins) {
            try {
              this.registerDamPlugin({plugin:plugin,                                             // eslint-disable-line no-undef  
               jsFileUrlL: `${window.location.origin}/damplugins${plugin.web_hook_path}` , 
               damInterface:{
                    userPrefSidemenuRegistrator: this.registerUserPreferenceSidemenu
                  }
              }) 
            } catch (error) {
              console.error(error)
            }
          }
        });
      },
      handleRouterDetails(){
        if (this.$route.matched[this.$route.matched.length-1].parent.name == "userPref" && this.selectedComponent != this.$route.name){
          this.changeToSelectedComponent(this.$route.name, this.$route.params.pluginId?this.$route.params.pluginId:this.$route.name.split("-")[0], false)
        }
      },
        ...mapActions("pluginRepo", ["getInstalledPluginsFromServer"]),
        ...mapGetters("registry",["getRegisteredPreferencesSidemenu"]),
        ...mapMutations("registry",["registerPreferenceSidemenu","unSetPreferencesSidemenu"]),
    },

    mounted(){
      this.setUpPreferencesSidemenu(this.preferenceSidemenulist);
    },
    created(){
      this.handleRouterDetails();
      Object.assign(this.parentRouteInfo, this.$route.params.parentinfo?this.$route.params.parentinfo:{})
      if(this.$route.params.showFavourites){
        this.changeComponentToFavorites();
      }
    }
}
</script>


<style scoped lang="scss">
$header-background: #1a1a1a;
$border-color: 1px solid #3a3a3a;
$background: #121212;
$bg-color-on-hover: #141414;
$body-bg-color: #0d0d0d;
$dull-text-color: #757575;
$options-text-color: #9c9c9c;
$text-color: #bbb;
$table-row-border: none;
$active-blue : #007bff;
$modal-border:1px solid #202020;
$modal-background: #121212;
$header-color:#9e9e9e;
$danger-color:#dc3545!important;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$secondary-border-color: 1px solid #2b2b2b;

#contact_number_input::-webkit-outer-spin-button,
#contact_number_input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.modal-dialog {
  max-width: 840px;
  width: 840px;
  height: 80%;
  margin: 0;
  padding: 0;
}
  
.modal-content {
  height: auto;
  min-height: 100%;
  border: 0 none;
  border-radius: 0;
  box-shadow: none;
   background: $primary-background !important;
  border: $secondary-border-color;
  .modal-body{
    background: $primary-background;
    height: 300px;
    user-select: text !important; 
    cursor:text;
    display: inline-flex;
    flex-direction: column;
  }
}

.modal {
  text-align: center;
  padding: 0 !important;
  display: block;
  position: fixed;
  inset-inline-start: 0px;
  top: 10%;
}
.modal:before {
  content: "";
  display: inline-block;
  height: 100vh;
  vertical-align: middle;
  margin-inline-end: -4px;
  position: fixed;
  width: 100vw;
  inset-inline-start: 0;
  top: 0;
  background: #00000094;
}
.modal:before {
content: '';
display: inline-block;
height: 100%;
vertical-align: middle;
margin-inline-end: -4px;
}
.modal-dialog {
display: inline-block;
text-align: start;
vertical-align: middle;
}

.modal-header .close {
    margin: 0px !important;
    padding: 1rem 0rem !important;
}

.btn{
    font-size:14px !important;
    height:100%;
}
.users-basic-info-table {
  font-size: 15px;
  tbody {
    margin: 10px;
    .key-div {
      text-align: end;
      color: $dull-text-color;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
    }
  }
}
table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: $table-row-border !important;
      border-bottom: $table-row-border !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: $table-row-border !important;
    }
  }
}
.validationmessage{
  color:$danger-color;
  font-size: 11px;
}

.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue !important;
    background: #1a1e21 !important;
}

.modal-header,.modal-footer{
    border: none !important;
    background: #15181B;
    .modal-title{
      color:$header-color;
    }
}

ul{
    list-style-type: none;
}

.primary-btn-style{
    button{
        height: 35px;
        width: 70px;
    font-size:14px;
    }
}

.secondary-btn-style{
  color:$text-color;
}

.sidebar{
    height:40px !important;
    color: $options-text-color;
    display:flex;
    align-items: center;
    justify-content: start;
    text-align: start;
    padding-inline-start: 10%;
    border-radius: 10px;
}

.sidenavbar{
  background: #15181B;
  color: $options-text-color;
}

.sidebar:hover{
    color: $text-color;
}
table.users-basic-info-table .editIcon {
  visibility: hidden;
}
table.users-basic-info-table td.value-div:hover .editIcon {
  visibility: visible;
}
.editIcon {
  margin-inline-start: 9px;
}

.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}
</style>